import {EditableFieldModel} from "./edit-component.model";
import {FieldType} from "./model.map";
export class SubscriptionModel {
        packages =  new EditableFieldModel('packages', FieldType.array, [
            new OnePackageModel()
        ], OnePackageModel);
        fieldsMap = [this.packages];

        constructor(data?: {packages?: any}) {
            if(data?.packages?.value.length > 0) {
                this.packages.value = [];
                for(let packaged of data?.packages.value){
                    this.packages.value.push(new OnePackageModel(packaged));
                }
            }
        }
}



export class OnePackageModel {
    title = new EditableFieldModel('Title', FieldType.text, 'Basic');
    description = new EditableFieldModel('Description', FieldType.text, 'Description for whom is it');
    price = new EditableFieldModel('price', FieldType.text, 10);
    buttonText = new EditableFieldModel('Button text', FieldType.text, 'Buy plan');
    buttonLink = new EditableFieldModel('Button link', FieldType.text, 'https://buy.stripe.com/6oE3f4bhU32Fenm9AN');
    allowedOptions = new EditableFieldModel('Enabled features for plan', FieldType.array, [
        new AllowedOption({option: 'Feature 1'}),
        new AllowedOption({option: 'Feature 2'})
    ], AllowedOption);

    fieldsMap = [this.price, this.allowedOptions, this.description, this.title, this.buttonText, this.buttonLink];
    constructor(data?: {title?: any, description?: any, allowedOptions?: any, price?: any, buttonText?: any, buttonLink?: any}) {
        if(data?.title){
            this.title.value = data?.title.value;
        }
        if(data?.description){
            this.description.value = data?.description.value;
        }
        if(data?.buttonText){
            this.buttonText.value = data?.buttonText.value;
        }
        if(data?.buttonLink){
            this.buttonLink.value = data?.buttonLink.value;
        }
        if(data?.allowedOptions){
            this.allowedOptions.value = []
            for(let option of data?.allowedOptions.value){
                this.allowedOptions.value.push(new AllowedOption(option));
            }
        }
        if(data?.price){
            this.price.value = data?.price.value;
        }
    }
}

export class AllowedOption {
    option = new EditableFieldModel('Option', FieldType.text, 'New feature');
    fieldsMap = [this.option];
    constructor(data?: {option?: any}) {
        if(data?.option){
            this.option.value = data.option.value;
        }
    }
}
